import { createFileRoute, redirect } from '@tanstack/react-router'
import { FEATURES, isFeatureEnabled } from '@/utils/feature-flag.ts'
import { Stack } from '@mui/material'
import { PageHeader } from '@/components/PageHeader/PageHeader.tsx'
import { useTranslation } from 'react-i18next'
import i18n from '@/i18n.ts'
import { VehicleDriverAllocationList } from '@/features/mission/components/layout/VehicleDriverAllocationList.tsx'
import { useCompany } from '@/contexts'

export const Route = createFileRoute('/_authenticated/$companySlug/fleet-allocation/')({
  beforeLoad: ({ context }) => {
    if (!isFeatureEnabled(FEATURES.FLEET_ALLOCATION)) {
      throw redirect({ to: '/not-found' })
    }
    // TODO ADD vehicle_write or user_write
    context.auth.rejectIfMissingPermissions(['VEHICLE_READ', 'USER_READ'])
  },
  head: () => ({
    meta: [{ title: i18n.t('_routes:routes.fleet_allocation.main.title') }]
  }),
  component: RouteComponent
})

function RouteComponent() {
  const { t } = useTranslation('_routes')
  const { sites } = useCompany()
  const { sites: filterSites } = Route.useSearch()

  return (
    <Stack spacing={3} sx={{ height: '100%' }}>
      <PageHeader subtitle={t('routes.fleet_allocation.main.subtitle')}>
        {t('routes.fleet_allocation.main.title')}
      </PageHeader>
      <VehicleDriverAllocationList selectedSiteIds={filterSites} sites={sites} />
    </Stack>
  )
}
